export const PLACEHOLDER_TEXT_ID = 'editor.content.placeholder.11';

export const ANALYTICS_SOURCE = 'next-FullPageEditorComponent';
